var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('v-list',_vm._l((_vm.menuItems),function(item){return _c('v-list-tile',{key:item.title,attrs:{"to":item.link}},[_c('v-list-tile-content',{staticStyle:{"color":"#DC4C46"}},[_vm._v(_vm._s(item.title))])],1)}),1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }